export class LotClubbingViewReq {
    lotId?: number;
    constructor( lotId?: number){
       this.lotId = lotId;
    }
}